import Icon from '../components/Icon.vue'

Icon.register({
  'hourglass-end': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M360 64c0 91-51 167.7-120.8 192 69.8 24.3 120.8 101 120.8 192 13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24 0-91 51-167.7 120.8-192-69.8-24.3-120.8-101-120.8-192-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24zM192 208c57.5 0 104-66.1 104-144h-208c0 77.5 46.2 144 104 144z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hourglass-end.js
// module id = 1468
// module chunks = 0